module.exports = __webpack_public_path__ + "static/img/address.a46df94e.png";